var video = {
	youtube: {
		active: false,
		first: true,
		$this: null,
		$wrap: null,
		$sitewide: null,
		open: function( $this ) {
			if (video.youtube.active == false) {
				video.youtube.active = true;
				video.youtube.$wrap.show();
				setTimeout(function() {
					$('body').icons.init('.svg-icon', video.youtube.$wrap);
					video.youtube.$wrap.addClass('active');
					if (video.youtube.first == true) {
						video.youtube.first = false;
						$('body').youtube.initHero($this);
					} else {
						$('body').youtube.initHero.play($this);
					}
				}, 100);
			}
		},
		close: function() {
			if (video.youtube.active == true) {
				video.youtube.active = false;
				video.youtube.$wrap.removeClass('active');
				$('body').youtube.initHero.pause(video.youtube.$this);
				setTimeout(function() {
					video.youtube.$wrap.hide();
				}, 500);
			}
		}
	},
	init: function() {
		video.youtube.$this = $('.youtube');
		video.youtube.$wrap = $('.youtube-wrap');
		$('.js-play-youtube').click(function(e) {
			e.preventDefault();
			var $this = $(this).closest('.youtube').find('.youtube-wrap .youtube');
			video.youtube.open( $this );
		});
		$('.youtube-wrap .close-youtube').click(function(e) {
			e.preventDefault();
			video.youtube.close();
		});
	},
};
